var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.onSave.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Upload PFA File"
    }
  }, [_c('b-form-file', {
    attrs: {
      "accept": _vm.accept,
      "browse-text": "Browse"
    },
    on: {
      "input": _vm.onFileChange
    },
    model: {
      value: _vm.localFile,
      callback: function callback($$v) {
        _vm.localFile = $$v;
      },
      expression: "localFile"
    }
  })], 1), _vm.isPdf ? _c('div', {
    staticClass: "rounded p-2"
  }, [_c('vue-pdf-embed', {
    staticStyle: {
      "height": "500px",
      "width": "100%"
    },
    attrs: {
      "source": _vm.pdfSrc,
      "height": 500
    }
  })], 1) : _vm.isExcel ? _c('div', {
    staticClass: "table-responsive rounded p-2"
  }, [_c('table', {
    staticClass: "table table-sm table-bordered mb-0"
  }, [_c('tbody', _vm._l(_vm.excelPreview, function (row, rIdx) {
    return _c('tr', {
      key: rIdx
    }, _vm._l(row, function (cell, cIdx) {
      return _c('td', {
        key: cIdx
      }, [_vm._v(_vm._s(cell))]);
    }), 0);
  }), 0)])]) : _c('div', {
    staticClass: "text-muted"
  }, [_vm._v("No preview available.")]), _c('div', {
    staticClass: "d-flex justify-content-end mt-3"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.saving || !_vm.localFile
    }
  }, [_vm._v(" " + _vm._s(_vm.saving ? 'Saving...' : 'Save') + " ")])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }